export const normalizeChatResponse = (value) => String(value ?? '')
   .replace(/```(?:\w+)?\s*/g, '')
   .replace(/```/g, '')
   .replace(/\*\*(.*?)\*\*/gs, '$1')
   .replace(/__(.*?)__/gs, '$1')
   .replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1$2')
   .replace(/\*{2,3}/g, '')
   .replace(/^\s{0,3}#{1,6}\s+/gm, '')
   .replace(/^\s*[-*+]\s+/gm, '• ')
   .replace(/`([^`\n]+)`/g, '$1')
   .trim();
